import { defineStore } from 'pinia';
import { ref } from 'vue';

// Initial form definition template (Contact Form)
const CONTACT_FORM_DEFINITION = `type form
name Contact form
success-message Thank you for contacting us. We'll get back to you soon
design
  background #f5f5f5

type h1
text Contact us

type text
name full_name
label Full Name
placeholder John Doe
validations required|length:1,50

type email
name email
label Email Address
placeholder john@example.com
validations required|email

type textarea
name message
label Message
placeholder Please enter your message here...
rows 4
validations required

type submit
label Send Message
`

// Default form is the contact form template
const DEFAULT_FORM_DEFINITION = CONTACT_FORM_DEFINITION

export const useStudioStore = defineStore('studio', () => {
  // Raw form definition string
  const formDefinition = ref(DEFAULT_FORM_DEFINITION)
  const publishing = ref(false) // whether publish is currently active
  const saving = ref(false) // whether publish is currently active
  const showSnippets = ref(false)
  const mediaToken = ref('')
  const mediaApiBaseUrl = ref('')

  // Parsed form schema object
  const formSchema = ref({
    blocks: [],
    design: { background: "#f5f5f5" },
    endpoint: "https://api.form-data.com/f/xxx",
    successMessage: "Form submitted successfully!",
    failMessage: "",
    classes: {},
    css: [],
    meta: {},
    removeBranding: false,
  })

  // Update the form definition and optionally the schema
  function updateForm(newDefinition, newSchema = null) {
    formDefinition.value = newDefinition

    if (newSchema) {
      formSchema.value = newSchema
    }
  }

  // Update just the parsed schema
  function updateSchema(newSchema) {
    formSchema.value = newSchema
  }

  // Apply a template by ID
  function applyTemplate(template) {
    formDefinition.value = template
    // Reset schema - it will be updated when the editor parses the new definition
    formSchema.value = {
      blocks: [],
      design: { background: "#f5f5f5" },
      endpoint: "https://api.form-data.com/f/xxx",
      successMessage: "Form submitted successfully!",
      failMessage: "",
      classes: {},
      css: [],
      meta: {},
      removeBranding: false,
    }
    return true
  }

  function $reset() {
    formDefinition.value = DEFAULT_FORM_DEFINITION
    formSchema.value = {
      blocks: [],
      design: { background: "#f5f5f5" },
      endpoint: "https://api.form-data.com/f/xxx",
      successMessage: "Form submitted successfully!",
      failMessage: "",
      classes: {},
      css: [],
      meta: {},
      removeBranding: false,
    }
  }

  return {
    $reset,
    formDefinition,
    formSchema,
    updateForm,
    updateSchema,
    applyTemplate,
    publishing,
    saving,
    showSnippets,
    mediaToken,
    mediaApiBaseUrl
  }
})

